import FilterConfig from './FilterConfig.json';

const filterConvert = (filter, code, convert) => {
  const brightness = {};
  const contrast = {};
  const saturation = {};
  const tint = {};
  const blur = {};
  const vignette = {};
  const xProcess = {};
  const intensity = {};
};

const convertBase = num => {
  return {
    from: baseFrom => {
      return {
        to: baseTo => {
          return parseInt(num, baseFrom).toString(baseTo);
        },
      };
    },
  };
};

const hex2dec = num => {
  return convertBase(num)
    .from(16)
    .to(10);
};

const valsRengeConfig = {
  brightness: { intercept: { valFrom: -0.5, valTo: 0.5, rangeFrom: -100, rangeTo: 100 } },
};

let filterValues;

const contrastSlope = [
  1,
  1.006036217,
  1.012145749,
  1.018329939,
  1.024590164,
  1.030927835,
  1.037344398,
  1.043841336,
  1.050420168,
  1.057082452,
  1.063829787,
  1.070663812,
  1.077586207,
  1.084598698,
  1.091703057,
  1.098901099,
  1.10619469,
  1.113585746,
  1.121076233,
  1.128668172,
  1.136363636,
  1.14416476,
  1.152073733,
  1.160092807,
  1.168224299,
  1.176470588,
  1.184834123,
  1.193317422,
  1.201923077,
  1.210653753,
  1.219512195,
  1.228501229,
  1.237623762,
  1.246882793,
  1.256281407,
  1.265822785,
  1.275510204,
  1.285347044,
  1.295336788,
  1.305483029,
  1.315789474,
  1.326259947,
  1.336898396,
  1.347708895,
  1.358695652,
  1.369863014,
  1.38121547,
  1.39275766,
  1.404494382,
  1.416430595,
  1.428571429,
  1.44092219,
  1.453488372,
  1.46627566,
  1.479289941,
  1.492537313,
  1.506024096,
  1.519756839,
  1.533742331,
  1.547987616,
  1.5625,
  1.577287066,
  1.592356688,
  1.607717042,
  1.623376623,
  1.639344262,
  1.655629139,
  1.672240803,
  1.689189189,
  1.706484642,
  1.724137931,
  1.742160279,
  1.76056338,
  1.779359431,
  1.798561151,
  1.818181818,
  1.838235294,
  1.858736059,
  1.879699248,
  1.901140684,
  1.923076923,
  1.945525292,
  1.968503937,
  1.992031873,
  2.016129032,
  2.040816327,
  2.066115702,
  2.092050209,
  2.118644068,
  2.145922747,
  2.173913043,
  2.202643172,
  2.232142857,
  2.262443439,
  2.293577982,
  2.325581395,
  2.358490566,
  2.392344498,
  2.427184466,
  2.463054187,
  2.5,
];
const contrastIntercept = [
  0,
  -0.003018109,
  -0.006072874,
  -0.009164969,
  -0.012295082,
  -0.015463918,
  -0.018672199,
  -0.021920668,
  -0.025210084,
  -0.028541226,
  -0.031914894,
  -0.035331906,
  -0.038793103,
  -0.042299349,
  -0.045851528,
  -0.049450549,
  -0.053097345,
  -0.056792873,
  -0.060538117,
  -0.064334086,
  -0.068181818,
  -0.07208238,
  -0.076036866,
  -0.080046404,
  -0.08411215,
  -0.088235294,
  -0.092417062,
  -0.096658711,
  -0.100961538,
  -0.105326877,
  -0.109756098,
  -0.114250614,
  -0.118811881,
  -0.123441397,
  -0.128140704,
  -0.132911392,
  -0.137755102,
  -0.142673522,
  -0.147668394,
  -0.152741514,
  -0.157894737,
  -0.163129973,
  -0.168449198,
  -0.173854447,
  -0.179347826,
  -0.184931507,
  -0.190607735,
  -0.19637883,
  -0.202247191,
  -0.208215297,
  -0.214285714,
  -0.220461095,
  -0.226744186,
  -0.23313783,
  -0.23964497,
  -0.246268657,
  -0.253012048,
  -0.259878419,
  -0.266871166,
  -0.273993808,
  -0.28125,
  -0.288643533,
  -0.296178344,
  -0.303858521,
  -0.311688312,
  -0.319672131,
  -0.32781457,
  -0.336120401,
  -0.344594595,
  -0.353242321,
  -0.362068966,
  -0.371080139,
  -0.38028169,
  -0.389679715,
  -0.399280576,
  -0.409090909,
  -0.419117647,
  -0.42936803,
  -0.439849624,
  -0.450570342,
  -0.461538462,
  -0.472762646,
  -0.484251969,
  -0.496015936,
  -0.508064516,
  -0.520408163,
  -0.533057851,
  -0.546025105,
  -0.559322034,
  -0.572961373,
  -0.586956522,
  -0.601321586,
  -0.616071429,
  -0.631221719,
  -0.646788991,
  -0.662790698,
  -0.679245283,
  -0.696172249,
  -0.713592233,
  -0.731527094,
  -0.75,
];

const codeMap = {
  brightness: 0,
  contrast: 1,
  saturation: 2,
  tint: 3,
  blur: 4,
  vignette: 5,
  xProcess: 6,
  intensity: 7,
};

const brightness = () => {
  const valsRenge = { intercept: { from: -0.5, to: 0.5 } };
  let valsProps = {};
  const hex = filterValues[codeMap.brightness];
  const per = hex2dec(hex) - 100;
  Object.keys(valsRenge).map((item, index) => {
    let valDiff = valsRenge[item].to - valsRenge[item].from;
    valsProps = {
      ...valsProps,
      [item]: {
        from: valsRenge[item].from,
        to: valsRenge[item].to,
        diff: valDiff,
        steps: valDiff / 200,
      },
    };
  });
  const brightnessProps = {
    valsProps: valsProps,
    hex: hex,
    per: per,
  };
  return brightnessProps;
  // const valDiff = valRenge.to - valRenge.from;
};

const convertByRange = (propName, code) => {
  let vals;
  const prop = FilterConfig[propName];

  Object.keys(prop).map((item, index) => {
    if (prop[item].switch) {
      const dec = parseInt(hex2dec(code));
      const num = dec - 100;
      let converted;
      if (num < prop[item].keyPoint) {
        converted = prop[item].keyOff;
      } else {
        converted = prop[item].keyOn;
      }
      vals = {
        ...vals,
        [item]: converted,
        Dec: dec,
      };
    } else {
      if (prop[item].valMid || prop[item].valMid === 0) {
        let valDiffHi = prop[item].valTo - prop[item].valMid;
        let valDiffLo = prop[item].valMid - prop[item].valFrom;
        let rangeDiff = (prop[item].rangeTo - prop[item].rangeFrom) / 2;
        let stepHi = valDiffHi / rangeDiff;
        let stepLo = valDiffLo / rangeDiff;
        const dec = parseInt(hex2dec(code));
        let converted;

        if (dec > rangeDiff) {
          if (propName === 'contrast') {
            let num = dec - 100;
            if (item === 'slope') {
              converted = contrastSlope[num];
            } else {
              converted = contrastIntercept[num];
            }
          } else {
            converted = prop[item].valMid + stepHi * (dec - 100);
          }
        } else {
          converted = prop[item].valFrom + stepLo * dec;
        }
        vals = {
          ...vals,
          [item]: converted,
          Dec: dec,
        };
      } else {
        let valDiff = prop[item].valTo - prop[item].valFrom;
        let rangeDiff = prop[item].rangeTo - prop[item].rangeFrom;
        let step = valDiff / rangeDiff;
        const dec = parseInt(hex2dec(code));
        vals = {
          ...vals,
          [item]: prop[item].valFrom + step * dec,
          Dec: dec,
        };
      }
    }
  });

  return vals;
};

const tintByRange = code => {
  // const prop = FilterConfig[propName];

  let vals;
  const ranges = {
    0: { R: 0.1, G: 0, B: 0.08571428571428562, change: 'B', action: '-' },
    1: { R: 0.1, G: 0, B: 0, change: 'G', action: '+' },
    2: { R: 0.1, G: 0.1, B: 0, change: 'R', action: '-' },
    3: { R: 0, G: 0.1, B: 0, change: 'B', action: '+' },
    4: { R: 0, G: 0.1, B: 0.1, change: 'G', action: '-' },
    5: { R: 0, G: 0, B: 0.1, change: 'R', action: '+' },
    6: { R: 0.1, G: 0, B: 0.08571428571428562, change: 'B', action: '-' },
  };
  const dec = parseInt(hex2dec(code));
  const range = Math.floor(dec / 30);
  let change = (dec - 30 * range) * 0.003;
  if (ranges[range].action === '-') {
    change = change * -1;
  }
  if (ranges[range].change === 'R') {
    vals = {
      R: ranges[range].R + change,
      G: ranges[range].G,
      B: ranges[range].B,
      Des: dec,
    };
  }
  if (ranges[range].change === 'G') {
    vals = {
      R: ranges[range].R,
      G: ranges[range].G + change,
      B: ranges[range].B,
      Des: dec,
    };
  }
  if (ranges[range].change === 'B') {
    vals = {
      R: ranges[range].R,
      G: ranges[range].G,
      B: ranges[range].B + change,
      Dec: dec,
    };
  }

  return vals;
};

const xProcessByRange = code => {
  const dec = parseInt(hex2dec(code));
  const convert = convertByRange('xProcess', filterValues[6]);
  let R = '';
  let G = '';
  let B = '';
  Object.keys(convert).map((item, index) => {
    if (item.split('')[0] === 'r') {
      R = R + ' ' + convert[item];
    }
    if (item.split('')[0] === 'g') {
      G = G + ' ' + convert[item];
    }
    if (item.split('')[0] === 'b') {
      B = B + ' ' + convert[item];
    }
  });
  const vals = {
    R: R,
    G: G,
    B: B,
    Des: dec,
  };
  return vals;
};

const filterSet = filterCode => {
  filterValues = filterCode.match(/.{1,2}/g);
  const filters = {
    brightness: convertByRange('brightness', filterValues[0]),
    contrast: convertByRange('contrast', filterValues[1]),
    saturation: convertByRange('saturation', filterValues[2]),
    tint: tintByRange(filterValues[3]),
    blur: convertByRange('blur', filterValues[4]),
    vignette: convertByRange('vignette', filterValues[5]),
    xProcess: xProcessByRange(filterValues[6]),
  };

  return filters;
};

export { filterSet };
